import React, { useEffect, useState } from "react";
import { indexWrapCss, widthCss} from "./css/Goods.style";
import Header from "src/common/layouts/header/Header";
import ContentsIndex from "src/common/controls/ContentsIndex";
import GoodsList from "src/domain/goods/components/GoodsList";
import Footer from "src/common/layouts/footer/Footer";
import {ReactComponent as Filter} from 'src/assets/filter.svg';
import PostCardFilterContainer from './PostCardFilterContainer';
import Paging from "../../common/layouts/page/Paging";
import { useLoading } from '../../common/controls/LoadingContext';

const GoodsPage = ({postCardList,
                       currentPage,
                       totalPages,
                       onPageChange,
                       selectedGenreIndex,
                       setSelectedGenreIndex,
                       onToggleLike,

}: {postCardList: any;
    currentPage: number;
    totalPages: number;
    onPageChange: (newPage: number) => void;
    selectedGenreIndex: number,
    setSelectedGenreIndex: React.Dispatch<React.SetStateAction<number>>
    onToggleLike: (postId: string) => void;
}) => {
    const [search, setSearch] = useState<any>("");

    const onSearchHandler = (e: any) => {
        setSearch(e.target.value);
    };

    const handleClick = (index : number) => {
        setSelectedGenreIndex(index);
    };

    //back default가 최신순임
    const filter = [
        '최신순', '인기순'
    ]


    return (
        <div css={indexWrapCss}>
            <Header
                onChange={onSearchHandler}
                searchValue={search}
                name="search"
                activeFlag="postcard"
            />

            <div css={widthCss}>

               <div className="filter">

                   {filter.map((title, idx) => (
                       <PostCardFilterContainer
                           key={idx}
                           label={title}
                           isSelected={selectedGenreIndex === idx}
                           onClick={() => setSelectedGenreIndex(idx)}
                       />
                   ))}

                    {/*{filter.map((title, idx) => (
                        <button
                            className="shadow-md gap-2 bg-main rounded-[100px] w-[90px] h-[48px]" key={idx}  onClick={() => handleClick(idx)}
                                style={{
                                    backgroundColor: selectedGenreIndex === idx ? '#1BE386' : 'white',
                                }}>
                            <span className="font-namsan text-lg font-semibold"
                                  style={{
                                      color: selectedGenreIndex === idx ? 'white' : '#454545',
                                  }}
                            >{title}</span>
                        </button>
                    ))}*/}


                </div>

                <GoodsList postCardList={postCardList} onToggleLike={onToggleLike} />

                <Paging totalPages={totalPages} currentPage={currentPage} onPageChange={onPageChange} />

            </div>
            <Footer/>

        </div>
    );
};

export default GoodsPage;
